import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

// Imported components
import NavigationBar from "../../components/nav/NavigationBar";
import PrimaryButton from "../../components/ui/PrimaryButton";

// Imported utils
import { isLoggedIn } from "../../utils/user";

// Styled components
const BackButton = styled(PrimaryButton)`
  background: var(--terbine-blue);
  font-family: Inter, Oxygen, Roboto, sans-serif;

  &:hover {
    background: lab(from var(--terbine-blue) calc(l - 5) a b / 100);
  }
`;

const Container = styled.div`
  align-items: center;
  background: white;
  display: flex;
  flex-direction: column;
  gap: 0px;
  height: 100vh;
  justify-content: flex-start;
  padding: 80px 0 0 0;
  position: relative;
`;

const Description = styled.div`
  font-family: Inter, Oxygen, Roboto, sans-serif;
  font-size: max(16px, 1.25vw);
`;

const Section = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 3vh;
  height: 100%;
  justify-content: center;
`;

const Header = styled.div`
  font-family: Inter, Oxygen, Roboto, sans-serif;
  font-size: max(64px, 5vw);
  font-weight: bolder;
`;

const NoMatch = () => {
  const navigate = useNavigate();
  const loggedIn = isLoggedIn();

  return (
    <Container>
      {loggedIn && <NavigationBar />}

      <Section>
        <Header>404</Header>
        <Description>
          Oops! The page you're looking for cannot be found.
        </Description>
        <BackButton onClick={() => navigate("/dashboard")}>{`${
          loggedIn ? `Back` : `Go`
        } To ${loggedIn ? `Home` : `Login`}`}</BackButton>
      </Section>
    </Container>
  );
};

export default NoMatch;
